import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_UNIFORM}`;

/** 統編記事本 */
export default () => axios.get(API_PATH);
